export const subscriberItems = [
  {
    title: 'Прямые продажи\nклиентам',
    descr:
      'Один из наиболее\nэффективных\nи качественных способов\nпривлечения клиентов',
  },
  {
    title: 'Акции\nв социальных\nсетях',
    descr:
      'За счет осознанности\nподключения -\nэффективный подход\nпривлечения клиентов',
  },
  {
    title: 'Новостная/e-mail\nрассылка',
    descr:
      'Бесплатный период может\nзаинтересовать клиента\nи повысить его лояльность',
  },
  {
    title: 'Сайты,\nмобильные\nприложения',
    descr:
      'Расширяют возможности\nпривлечения клиентов\nв онлайн-кинотеатр KION',
  },
  {
    title: 'Чеки,\nполиграфия (промокоды)',
    descr:
      'Промокоды на чеках, листовках, стикерах могут привлечь внимание клиентов',
  },
  {
    title: 'Интеграция\nв программу лояльности',
    descr:
      'Интересное предложение как для клиентов партнера, так и для его сотрудников',
  },
]
